
export const TOGGLE_THEME = "TOGGLE_THEME";

export const SET_LANGUAGE = "SET_LANGUAGE";



// Action Types
export const LOG_PAGE_VISIT = "LOG_PAGE_VISIT";
export const FETCH_ANALYTICS = "FETCH_ANALYTICS";



export const TRACKING_ACTION = 'tracking_action';
export const TRACKING_ACTION_SUCCESS = 'tracking_action_success';
export const TRACKING_ACTION_FAILURE = 'tracking_action_failure';





//.........AUTH ACTIONS
export const AUTH_FIELD_CHANGED = "auth_field_changed";
export const LOGIN_USER = "login_user";
export const LOGIN_USER_SUCCESSFUL = "login_user_successful";
export const LOGIN_USER_FAILED = "login_user_failed";
export const LOGOUT_USER = "logout_user";
export const LOGOUT_USER_SUCCESSFUL = "logout_user_successful";
export const LOGOUT_USER_FAILED = "logout_user_successful";
export const REGISTER_USER = "register_user";
export const REGISTER_USER_SUCCESSFUL = "register_user_successful";
export const REGISTER_USER_FAILED = "register_user_failed";

//.......LAUNCH ACTIONS
export const LOGOUT = 'logout';


// Action Types
export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";


export const TALENT_SUBMISSION_REQUEST = 'TALENT_SUBMISSION_REQUEST';
export const TALENT_SUBMISSION_SUCCESS = 'TALENT_SUBMISSION_SUCCESS';
export const TALENT_SUBMISSION_FAILURE = 'TALENT_SUBMISSION_FAILURE';

export const TALENT_SEARCH_REQUESTS_FETCH = 'TALENT_SEARCH_REQUESTS_FETCH';
export const TALENT_SEARCH_REQUESTS_FETCH_SUCCESS = 'TALENT_SEARCH_REQUESTS_FETCH_SUCCESS';
export const TALENT_SEARCH_REQUESTS_FETCH_FAILURE = 'TALENT_SEARCH_REQUESTS_FETCH_FAILURE';

export const TALENT_SEARCH_REQUEST_UPDATE = 'TALENT_SEARCH_REQUEST_UPDATE';
export const TALENT_SEARCH_REQUEST_UPDATE_SUCCESS = 'TALENT_SEARCH_REQUEST_UPDATE_SUCCESS';
export const TALENT_SEARCH_REQUEST_UPDATE_FAILURE = 'TALENT_SEARCH_REQUEST_UPDATE_FAILURE';



export const ADD_ARTIST = "add_artist";
export const ADD_ARTIST_SUCCESS = "add_artist_success";
export const ADD_ARTIST_FAILURE = "add_artist_failure";

export const EDIT_ARTIST = "edit_artist";
export const EDIT_ARTIST_SUCCESS = "edit_artist_success";
export const EDIT_ARTIST_FAILURE = "edit_artist_failure";

export const FETCH_ARTISTS = "fetch_artists";
export const FETCH_ARTISTS_SUCCESS = "fetch_artists_success";
export const FETCH_ARTISTS_FAILURE = "fetch_artists_failure";

export const FETCH_ARTIST = "fetch_artist";
export const FETCH_ARTIST_SUCCESS = "fetch_artist_success";
export const FETCH_ARTIST_FAILURE = "fetch_artist_failure";

export const DELETE_ARTIST = "DELETE_ARTIST";
export const DELETE_ARTIST_SUCCESS = "DELETE_ARTIST_SUCCESS";
export const DELETE_ARTIST_FAILURE = "DELETE_ARTIST_FAILURE";


export const DELETE_PICTURE = "DELETE_PICTURE";
export const DELETE_PICTURE_SUCCESS = "DELETE_PICTURE_SUCCESS";
export const DELETE_PICTURE_FAILURE = "DELETE_PICTURE_FAILURE";


export const FETCH_MASTER_CODES_REQUEST = 'FETCH_MASTER_CODES_REQUEST';
export const FETCH_MASTER_CODES_SUCCESS = 'FETCH_MASTER_CODES_SUCCESS';
export const FETCH_MASTER_CODES_FAILURE = 'FETCH_MASTER_CODES_FAILURE';

export const CREATE_OR_UPDATE_MASTER_CODE_REQUEST = 'CREATE_OR_UPDATE_MASTER_CODE_REQUEST';
export const CREATE_OR_UPDATE_MASTER_CODE_SUCCESS = 'CREATE_OR_UPDATE_MASTER_CODE_SUCCESS';
export const CREATE_OR_UPDATE_MASTER_CODE_FAILURE = 'CREATE_OR_UPDATE_MASTER_CODE_FAILURE';
